export default "__VITE_PUBLIC_ASSET__72e14d54__"